import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PackageLogResponse, PackageRoomSession } from '@/models'

interface PackageLogRequest {
  buildingId?: number
  startDate?: number
  endDate?: number
  skip?: number
  limit?: number
}

interface PackageLogAPIResponse {
  sessions: PackageRoomSession[]
  count: number
}

export const PACKAGE_LOG_BASE_QUERY_KEY = 'useGetPackageLog'
export const getPackageLogQueryKey = (data: PackageLogRequest) => [PACKAGE_LOG_BASE_QUERY_KEY, data]

export const getPackageLog = async (
  params: PackageLogRequest,
  signal?: AbortSignal,
): Promise<PackageLogResponse> => {
  // Note the request fails without skip
  const { skip = 0, ...rest } = params
  const response = await authAPI.get<PackageLogAPIResponse>(`/package-room/sessions`, {
    params: { ...rest, skip },
    signal,
  })

  return {
    data: response.data.sessions,
    total: response.data.count ?? 0,
  }
}

export const useGetPackageLog = (data: PackageLogRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getPackageLog(data, signal),
    queryKey: getPackageLogQueryKey(data),
  })
}
